import { API_BASE_URL } from '../config/constants';
import { getRequest } from './api';

export const utilityService = {
  // Get all cities
  getCities: async () => {
    try {
      const response = await getRequest('cities');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get city by ID
  getCityById: async (cityId) => {
    try {
      const response = await getRequest(`cities/${cityId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get all categories
  getCategories: async () => {
    try {
      const response = await getRequest('categories');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get category by ID
  getCategoryById: async (categoryId) => {
    try {
      const response = await getRequest(`categories/${categoryId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Upload image
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(API_BASE_URL + 'images/upload', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();
      return data.fileUrl;
    } catch (error) {
      throw error;
    }
  },
};

export default utilityService;
